import React, { useState } from "react";
import style from "./index.module.scss";
import banner from "./image/banner.jpg";
import content from "./image/content.jpg";
import gonggao from "./image/gonggao.jpg";
import shengming from "./image/shengming.jpg";

function AboutUs() {
  const [isOverlayVisible, setOverlayVisible] = useState(false);

  return (
    <>
      <div className={style.banner}>
        <img src={banner} alt="专注金融服务 创造信用财富" />
      </div>
      {!isOverlayVisible ?
        <div className={style.content}>
          <div className={style.title}>
            <span className={style.info}>
              <span className={style.en}>COMANY PROIE</span>
              <span className={style.ch}>公司简介</span>
            </span>
            <span className={style.empty}></span>
          </div>
          <article>
            <img src={content} alt="深圳市融达融资担保有限公司" title="深圳市融达融资担保有限公司-关于我们" />
            <article>
              <h3>深圳市融达融资担保有限公司</h3>
              <h4>RONGDA FINANCING GUARANTY</h4>
              <p>
                深圳市融达融资担保有限公司成立于2004年2月20日，以稳健性、安全性、规范性、
                合法性、流动性、效益性为准则，拥有一支高素质且富有经验的，由工商管理、金
                融、财务和法律等专业人士组成经营团队的专业性融资担保公司。拥有丰富的金融
                行业资源整合能力，是一家具备良好发展潜力和盈利能力的商业担保公司。注册资
                本100800万元人民币，2024年获得中诚信信用评级AA+。
              </p>
              <p>
                公司经营许可经营范围为：为企业及个人提供贷款担保，票据承兑担保，贸易
                融资担保，项目融资担保，信用证担保等融资性担保，兼营诉讼保全担保，履约担
                保业务，与担保业务相关的融资咨询，财务顾问中介服务，以自有资金进行投资。
              </p>
            </article>
          </article>
          <div className={style.title}>
            <span className={style.info}>
              <span className={style.en}>NEWS CENTER</span>
              <span className={style.ch}>资讯中心</span>
            </span>
            <span className={style.empty}></span>
          </div>
          <article onClick={() => setOverlayVisible(true)} >
            <img className={style.gonggao} src={gonggao} alt="企业公告" title="企业公告-关于我们" />
            <div className={style.clickableArea}>
              <p className={style.clickableAreaTitle} >
                【关于不法分子假冒深圳市融达融资担保有限公司名义进行非法活动的严正声明】
              </p>
              <p className={style.date}>
                2025/03/18 15:42:23
              </p>
            </div>
          </article>
        </div>
        : <div
          className={style.content}
        >
          <div className={style.title}>
            <span className={style.info}>
              <span className={style.ch}>资讯详情</span>
            </span>
            <span className={style.empty}></span>
          </div>
          <article onClick={() => setOverlayVisible(false)} >
            <img className={style.shengming} src={shengming} alt="资讯详情" title="企业公告-关于我们" />
          </article>
        </div>
      }
    </>
  );
}

export default AboutUs;